/**
 * downloadService
 * -----------------------------------------------------------------------------
 * Descarga de PDF vía bridge nativo (tigerDownloadFile → tigerDownloadResult).
 * Spike D5: el wrapper rechaza data: URIs; se usa la URL http(s) del backend.
 * -----------------------------------------------------------------------------
 */

import {
  getPlatform,
  androidCall,
  iosPostMessage,
  awaitNativeCallback,
} from './nativeBridge';

/**
 * @param {string} url - URL http(s) del PDF en el backend
 * @param {string} fileName
 * @param {Object} [options]
 * @param {number} [options.timeoutMs=30000]
 * @returns {Promise<boolean>}
 */
export async function descargarPdfNativo(url, fileName, { timeoutMs = 30000 } = {}) {
  try {
    const pending = awaitNativeCallback('tigerDownloadResult', { timeoutMs });

    // TEMP DEBUG — quitar después
    console.log('[download] URL exacta a tigerDownloadFile:', JSON.stringify(url));
    console.log('[download] fileName:', JSON.stringify(fileName));
    if (getPlatform() === 'android') {
      androidCall('tigerDownloadFile', url, fileName, 'application/pdf');
    } else {
      iosPostMessage('tigerDownloadFile', {
        url,
        fileName,
        mimeType: 'application/pdf',
      });
    }

    const success = await pending;
    return success;
  } catch {
    return false;
  }
}
